import React, { Dispatch, FC, SetStateAction, useState } from "react";
import Button from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import LabelIcon from "../Reusable/LabelIcon";
import { useModal } from "contexts/modalContext/modalContext";
import CreateEditLabel from "./CreateEditLabel";
import { useToasts } from "react-toast-notifications";
import { sliceLabelName } from "../helpers";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import useMediaQueries from "hooks/useMediaQueries";

interface LabelAsI {
  onClose: Dispatch<SetStateAction<boolean>>;
  selectedMails: string[];
  builtIn?: boolean;
}

const LabelAs: FC<LabelAsI> = (props) => {
  const { onClose, selectedMails, builtIn } = props;
  const { getLabels, labelMails } = useInbox();
  const { getTextByKey } = useContent();
  const [checkedElements, setCheckedElements] = useState<string[]>([]);
  const { setModal } = useModal();
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const { desktopCondition } = useMediaQueries();
  const [showCreateLabelPopup, setShowCreateLabelPopup] = useState(false);

  const handleApply = async () => {
    setIsLoading(true);
    try {
      await labelMails(
        selectedMails,
        checkedElements.map((id) => +id)
      );
    } catch (err: any) {
      console.log(err);
      addToast(err?.message, {
        appearance: "error",
      });
      setIsLoading(false);
      onClose(false);
      return;
    }
    addToast(getTextByKey("label-added-to-selected-mails"), {
      appearance: "success",
    });
    setIsLoading(false);
    onClose(false);
  };

  const handleSelect = (labelId: string) => {
    if (!labelId) return;

    const exists = checkedElements.includes(labelId);
    if (exists) {
      setCheckedElements((prev) => prev.filter((value) => value !== labelId));
    } else {
      setCheckedElements((prev) => [...prev, labelId]);
    }
  };

  const handleCreateLabel = () => {
    if (desktopCondition) {
      setModal({
        modal: CreateEditLabel,
        props: {},
      });
    } else {
      setShowCreateLabelPopup(true);
    }
  };

  return (
    <>
      <CreateEditLabel
        showPopup={showCreateLabelPopup}
        setShowPopup={setShowCreateLabelPopup}
      />
      <div
        className={`label-as-list checkbox-list-dropdown${
          builtIn ? "-built-in" : ""
        }`}
      >
        {!builtIn && (
          <Icon
            name="x"
            large
            gray
            onClick={() => onClose(false)}
            iconClass="close-icon"
          />
        )}
        <h1>{getTextByKey("label-as")}</h1>
        <hr />
        <ul>
          {Object.values(getLabels())?.length ? (
            Object.values(getLabels())?.map((label: any) => (
              <li key={label.id} onClick={() => handleSelect(label.id)}>
                <div
                  className={`checkbox-wrapper ${
                    checkedElements.includes(label.id) ? "selected" : ""
                  }`}
                >
                  {checkedElements.includes(label.id) && (
                    <Icon name="newInbox/mark" iconClass="mark-icon" blue />
                  )}
                </div>
                {/*@ts-ignore*/}
                <Tooltip tooltipText={label.name}>
                  <span>{sliceLabelName(label.name)}</span>
                </Tooltip>
              </li>
            ))
          ) : (
            <div>{getTextByKey("no-labels")}</div>
          )}
        </ul>
        <hr />
        <div className="create-label-wrapper" onClick={handleCreateLabel}>
          <LabelIcon color="#9CA9AF" />
          <span>{getTextByKey("create-new-label")}</span>
        </div>
        <div className="apply-button-wrapper">
          <Button onClick={handleApply} disabled={isLoading}>
            {getTextByKey("label-apply")}
          </Button>
        </div>
      </div>
    </>
  );
};

export default LabelAs;
